import { render, staticRenderFns } from "./SortItem.vue?vue&type=template&id=15dcf88e&"
import script from "./SortItem.vue?vue&type=script&lang=js&"
export * from "./SortItem.vue?vue&type=script&lang=js&"
import style0 from "./SortItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports